import request from '@/http/request';

// 获取PO单统计数据
export function getPOStatistics() {
  return request({
    url: '/api/v1/ops/po_statistics',
    method: 'get'
  });
}

// 获取PO单超时统计数据
export function getPoTimeoutStatistics() {
  return request({
    url: '/api/v1/ops/po_timeout_statistics',
    method: 'get'
  });
}
// 获取PO单园区统计数据
export function getPoRegionStatistics() {
  return request({
    url: '/api/v1/ops/po_campus_statistics',
    method: 'get'
  });
}

// 获取PO单受理/驳回统计数据
export function getPoAcceptStatistics() {
  return request({
    url: '/api/v1/ops/po_accept_statistics',
    method: 'get'
  });
}
// 获取PO单分析统计数据
export function getPoAnalysis() {
  return request({
    url: '/api/v1/ops/po_analysis',
    method: 'get'
  });
}


